// extracted by mini-css-extract-plugin
export default {"-large":"contextual-menu-divider-module__-large--F4gQu","divider":"contextual-menu-divider-module__divider--CorsV"};